import { gql, TypedDocumentNode } from "@apollo/client";

import { Revision, MutationRevisionCreateArgs } from "types/generated";

export const COMMIT_SPACELIFT_VCS_FILES: TypedDocumentNode<
  { revisionCreate: Revision },
  MutationRevisionCreateArgs
> = gql`
  mutation CommitSpaceliftVcsFiles($input: RevisionCreateInput!) {
    revisionCreate(input: $input) {
      id
    }
  }
`;
